jQuery( document ).ready( function() {
	// Array to store selected slugs
	let industrySelectedSlugs = [];
	let regionSelectedSlugs = [];
	let marketSelectedSlugs = [];
	// Attach a click event handler to checkboxes and labels

	// Function to update the applied filter tags
	function updateTags( selectedSlugsArrays, appliedFilterTags ) {
		appliedFilterTags.empty();

		function createSpan( slug ) {
			const capitalizedText = slug.charAt( 0 ).toUpperCase() + slug.slice( 1 );
			return `<span data-slug="${ slug }" class="remove-span">${ capitalizedText }</span>`;
		}

		function updateSelectedSlugs() {
			const allSelectedSlugs = [].concat( ...selectedSlugsArrays );
			jQuery( '#selected-slugs' ).text( allSelectedSlugs.join( ', ' ) );
		}

		function removeSpanClickHandler() {
			const slugToRemove = jQuery( this ).data( 'slug' );

			selectedSlugsArrays.forEach( ( selectedSlugsArray, index ) => {
				const slugIndex = selectedSlugsArray.indexOf( slugToRemove );

				if ( slugIndex !== -1 ) {
					selectedSlugsArrays[ index ].splice( slugIndex, 1 );
				}
			} );

			updateSelectedSlugs();
			updateTags( selectedSlugsArrays, appliedFilterTags );
			sendAjaxRequest();

			jQuery( `.filter-item[data-slug="${ slugToRemove }"]` ).prop( 'checked', false );
		}

		function appendSpans( array ) {
			array.forEach( function( slug ) {
				const spanTag = createSpan( slug );
				appliedFilterTags.append( spanTag );
			} );
		}

		selectedSlugsArrays.forEach( appendSpans );

		jQuery( '.remove-span' ).on( 'click', removeSpanClickHandler );
	}

	jQuery( '#industry-taxonomy_terms .filter-item' ).on( 'click', function() {
		const slug = jQuery( this ).data( 'slug' );
		if ( jQuery( this ).is( ':checked' ) ) {
			industrySelectedSlugs.push( slug );
		} else {
			const index = industrySelectedSlugs.indexOf( slug );
			if ( index !== -1 ) {
				industrySelectedSlugs.splice( index, 1 );
			}
		}
		jQuery( '#selected-slugs' ).text( industrySelectedSlugs.join( ', ' ) );
		updateTags( [ regionSelectedSlugs, industrySelectedSlugs, marketSelectedSlugs ], jQuery( '.applied-filter-tags' ) );
		sendAjaxRequest();
		// console.log( 'industry' );
	} );

	// Updating Region Filter Tags

	jQuery( '#region-taxonomy_terms .filter-item' ).on( 'click', function() {
		const slug = jQuery( this ).data( 'slug' );
		if ( jQuery( this ).is( ':checked' ) ) {
			// If checked, add the slug to the array
			regionSelectedSlugs.push( slug );
		} else {
			// If unchecked, remove the slug from the array
			const index = regionSelectedSlugs.indexOf( slug );
			if ( index !== -1 ) {
				regionSelectedSlugs.splice( index, 1 );
			}
		}
		jQuery( '#selected-slugs' ).text( regionSelectedSlugs.join( ', ' ) );
		updateTags( [ regionSelectedSlugs, industrySelectedSlugs, marketSelectedSlugs ], jQuery( '.applied-filter-tags' ) );
		sendAjaxRequest();
		// console.log( 'region' );
	} );

	// Update the Market Tags
	jQuery( '#market-taxonomy_terms .filter-item' ).on( 'click', function() {
		// Get the data-slug attribute
		const slug = jQuery( this ).data( 'slug' );

		// Check if the checkbox is checked or unchecked
		if ( jQuery( this ).is( ':checked' ) ) {
			// If checked, add the slug to the array
			marketSelectedSlugs.push( slug );
		} else {
			// If unchecked, remove the slug from the array
			const index = marketSelectedSlugs.indexOf( slug );
			if ( index !== -1 ) {
				marketSelectedSlugs.splice( index, 1 );
			}
		}

		// Update the display with selected slugs
		jQuery( '#selected-slugs' ).text( marketSelectedSlugs.join( ', ' ) );

		// Update the applied filter tags
		updateTags( [ regionSelectedSlugs, industrySelectedSlugs, marketSelectedSlugs ], jQuery( '.applied-filter-tags' ) );
		sendAjaxRequest();
		//  console.log( 'market' );
	} );
	jQuery( '#ajax-clear' ).on( 'click', function() {
		// console.log( 'Event Trigger' );
		industrySelectedSlugs = [];
		regionSelectedSlugs = [];
		marketSelectedSlugs = [];
		jQuery( '.filter-item' ).prop( 'checked', false );
		updateTags( [ regionSelectedSlugs, industrySelectedSlugs, marketSelectedSlugs ], jQuery( '.applied-filter-tags' ) );
		sendAjaxRequest();
	} );

	// Function to update the applied filter tags
	function sendAjaxRequest() {
		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'customer_filter',
				industrySelectedSlugs,
				regionSelectedSlugs,
				marketSelectedSlugs,

			},
			success( response ) {
				if ( response ) {
					jQuery( '#customer-post-container' ).html( response );
					// console.log( response );
				// Append the new posts to the container.
				}
			// Restore the button text after loading
			},
		} );
	}
} );
